import dialogStyles from "../dialogStyles.module.css";

export default function DayTypeTitle({ label }) {
  return (
    <div className={dialogStyles.dialogDayTypeTitleContainer}>
      <div className={dialogStyles.dialogDayTypeTitle}>{label}</div>
    </div>
  );
}
